module.exports = __webpack_public_path__ + "static/media/icon-office.171a1099.svg";